// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Address } from './address';
import { Admin } from './admin';
import { Contact } from './contact';
import { Counterparty } from './counterparty';
import { CounterpartyDatum } from './counterparty-datum';
import { CreditorClaim } from './creditor-claim';
import { CreditorClass } from './creditor-class';
import { CreditorContact } from './creditor-contact';
import { CreditorDatum } from './creditor-datum';
import { CreditorDividend } from './creditor-dividend';
import { DocumentRecipient } from './document-recipient';
import { Employee } from './employee';
import { Entry } from './entry';
import { MeetingAttendance } from './meeting-attendance';
import { ProxyType } from './proxy-type';
import { Security } from './security';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Creditor extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  creditorId!: number;
  addressId!: number;
  adminId!: number;
  advisedOwing!: number;
  altAddress?: string;
  altPayee?: string;
  altReference?: string;
  captureReference?: string;
  contactId?: number;
  contingentAdvisedGrossClaim!: number;
  contingentRatagrossClaim!: number;
  counterpartyId?: number;
  createdBy!: string;
  createdDate?: Date;
  creditorClassId!: number;
  creditorSubClassId!: number;
  debtDate!: Date;
  employeeId?: number;
  entryId?: number;
  flags?: number;
  isEraclaimAdmin?: boolean;
  isManualCalc?: boolean;
  isOnComittee!: boolean;
  isPrincipalSecuredCreditor!: boolean;
  isRatacreditor!: boolean;
  mailToParent!: boolean;
  memo?: string;
  noClaimAdvised?: boolean;
  password?: string;
  podamount!: number;
  poddate!: Date;
  podisInformal!: boolean;
  podvotingAdmittedAmount!: number;
  podwithdrawn!: number;
  proxyHolder?: string;
  proxyTypeId?: number;
  rataowing!: number;
  reference1?: string;
  reference2?: string;
  reference3?: string;
  rejectionReasons?: string;
  subCounterpartyId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  webFlags?: number;
  address!: Address;
  admin!: Admin;
  contact!: Contact;
  counterparty!: Counterparty;
  counterpartyData!: CounterpartyDatum[];
  creditorClaims!: CreditorClaim[];
  creditorClass!: CreditorClass;
  creditorContacts!: CreditorContact[];
  creditorDatum!: CreditorDatum;
  creditorDividends!: CreditorDividend[];
  documentRecipients!: DocumentRecipient[];
  employee!: Employee;
  entry!: Entry;
  meetingAttendances!: MeetingAttendance[];
  proxyType!: ProxyType;
  securities!: Security[];
  subCounterparty!: Counterparty;
}

